export enum AutoOpenDrawer {
    Notifications = 'notifications',
    Microphone = 'microphone',
    Insights = 'insights',
}

export const AUTO_OPEN_DRAWER_PRIORITY: Record<AutoOpenDrawer, number> = {
    [AutoOpenDrawer.Notifications]: 1,
    [AutoOpenDrawer.Microphone]: 2,
    [AutoOpenDrawer.Insights]: 3,
};

export const NotificationResults = {
    Granted: 'granted',
    Denied: 'denied',
    Default: 'default',
};
